import React from "react";
import Tabs from "../containers/Tabs/";
//import ScrollButton from "../containers/ScrollButton/ScrollButton";
import "./Content.scss";

function Content(props) {
  return (
    <div className="content">
      <div className="content-wrapper">
        <div className="description-wrapper">
{/*           <p className="content-title">Términos y condiciones</p>
 */}         {/*  <p className="description">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
            consectetur, arcu quis vehicula sagittis, lorem nisi tempor erat,
            vitae egestas dui enim dapibus ligula.
          </p> */}
        </div>
        <div className="tabs-wrapper">
          <p className="content-wrapper_title">
            Términos y condiciones
          </p>
          <Tabs />
          {/* <ScrollButton/> */}
        </div>
      </div>
    </div>
  );
}

export default Content;
